import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'toggle-options',
  templateUrl: './toggle-options.component.html',
  styleUrls: ['./toggle-options.component.scss'],
  imports: [CommonModule],
})
export class ToggleOptionsComponent implements OnInit {
  currentSelectedOption!: number | string;

  @Input() options: Array<ToggleOptionType> = [];
  @Output() getSelectedOption = new EventEmitter<number | string>();

  constructor() {}

  ngOnInit(): void {
    this.currentSelectedOption = this.options.find((o) => o.isActive)!.id;
  }

  /**
   * Change active option
   * @param selectedOption     Selected option id
   */
  onOptionChange(selectedOption: number | string) {
    this.options.forEach((option) => {
      option.isActive = option.id === selectedOption;

      if (option.isActive && this.currentSelectedOption !== selectedOption) {
        this.currentSelectedOption = selectedOption;
        this.getSelectedOption.emit(option.id);
      }
    });
  }
}

export interface ToggleOptionType {
  id: number | string;
  name: string;
  isActive: boolean;
  enabled: boolean;
}
